// Components==============
import indexActivity from 'actions/activity/index';
import indexPhase from 'actions/phase/index';
import { ProcessGroups } from 'hooks/useProcessGroups';
import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './ProcessInfo.module.scss';
// =========================

export default function ProcessInfo({
  processGroups,
  user,
}: {
  processGroups?: ProcessGroups;
  user?: UserEntity;
}) {
  const translate = useTranslate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(indexPhase);
    dispatch(indexActivity);
  }, []);

  const activities = processGroups?.map((group) => ({
    phase: group.phase,
    proces: group.activities.filter(
      (activity) =>
        activity.process_type === 'App\\Activity' ||
        activity.process_type === 'App\\Training'
    ),
  }));

  const activityLength = activities?.map((act) => act.proces).flat().length;

  const description = processGroups?.[0]?.description;
  const safeDescription = typeof description !== 'string' && description;
  const designQuestion =
    safeDescription && 'design_question' in safeDescription
      ? safeDescription.design_question
      : '';

  return (
    <div styleName="wrapper">
      <h3>{designQuestion}</h3>
      <div styleName="subtitle-wrapper">
        {!!user && (
          <p>
            {user.first_name} {user.last_name}
          </p>
        )}
        <p>
          {`${processGroups?.length} ${translate(
            'project.terms.process-steps'
          )}`}
        </p>
        <p>{`${activityLength} ${translate('project.terms.activities')}`}</p>
      </div>
      <div styleName="dots">
        {processGroups?.map((group, i) => (
          <React.Fragment key={i}>
            {group.activities.map((p, index) => (
              <div key={index} styleName={`circle ${group.phase}`} />
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
